<template>
  <header class="" style="height: 562px">
    <!--
        <div class="details-banner" v-if="!bannerImg"></div>
    -->

    <a class="block banner">
      <img
        class="hidden lg:block"
        :src="bannerImg"
        style="width: 100%;height: 100%;"
        v-if="sourceType === 'img'"
      />
      <video
        id=""
        autoplay
        muted
        loop
        preload="auto"
        style="z-index: 200; width: 100%; height: auto"
        v-if="sourceType === 'video' && video"
      >
        <source type="video/mp4" :src="video" />
      </video>

      <div class="hero__content">
        <h1 class="mb-0">{{ title }}</h1>
        <p class="mb-0">{{ subTitle }}</p>
        <div
          v-if="showZiXun"
          @click="consultOpen = true"
          style="
            z-index: 999;
            margin-top: 14px;
            width: 140px;
            height: 44px;
            padding: 11px 27px;
            gap: 8px;
            background: #d7000f;
            cursor: pointer;
          "
        >
          <img src="../assets/images/talk.png" alt="" style="width: 18px" />
          <span
            style="
              color: #fff;
              text-align: center;
             
              font-size: 14px;
              font-style: normal;
              font-weight: 600;
              line-height: normal;
            "
            >立即咨询</span
          >
        </div>
      </div>

      <div class="boxs">
        <aside
          v-if="subList.length > 0"
          class="hidden lg:block absolute sublist-img"
          style="
            top: 50%;
            height: 344px;
            margin-top: -100px;
            left: 50%;
            width: 1280px;
            margin-left: -640px;
          "
        >
          <div
            v-for="(item, index) in subList"
            :key="index"
            :class="' box ' + subListClass[index]"
            @click="onSublist(item)"
          >
            <img :src="item.img" alt="无图片" />
            <h3>{{ item.title }}</h3>
          </div>
          <!--        <div class="box header " style="">-->
          <!--          <img :src="'/static/Rectangle.png'" />-->

          <!--          <div class="hero__content "  style="">-->
          <!--            <h1>{{ title }}</h1>-->
          <!--          </div>-->
          <!--        </div>-->
          <!--        <div class="box sidebar "   >-->
          <!--          <img :src="'/static/Rectangle.png'" />-->
          <!--          <div class="hero__content">-->
          <!--            <h1>{{ title }}</h1>-->
          <!--          </div>-->
          <!--        </div>-->
        </aside>
      </div>
      <aside class="hidden lg:block absolute sublist-b">
        <slot name="subList"> </slot>
      </aside>
    </a>

    <consult
      v-if="consultOpen"
      title="立即咨询"
      :dialogVisible="consultOpen"
      productId="0"
      @cancel="consultOpen = false"
    >
    </consult>
  </header>
</template>
<script>
import { listBanner } from "@/api";

export default {
  name: "BannerImg",
  props: {
    bannerPosition: {
      type: String,
      default: "JJFA_BANNER",
    },
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    remakes: {
      type: String,
      default: "",
    },
    subList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    showZiXun: {
      type: Boolean,
      default: false,
    },

    onSublist: {},
  },
  data() {
    return {
      consultOpen: false,
      bannerPath: "",
      video: "",
      sourceType: "img",
      bannerImg: "",
      subListClass: ["content", "header", "sidebar"],
    };
  },
  methods: {
    async getBanner() {
      const res = await listBanner({
        bannerPosition: this.bannerPosition,
        useFlag: "1",
      });

      const data = res.rows.find(
        (v) =>
          (v.bannerImg && v.sourceType == "img") ||
          (v.video && v.sourceType == "video")
      );
      if (!data) return;
      this.sourceType = data.sourceType;
      this.bannerImg = data.bannerImg;
      this.video = data.video;
      this.bannerPath = data.link;
      this.title = data.title;
      this.subTitle = data.subTitle;

      this.$store.dispatch("app/setPartner", data);
    },
  },
  created() {
    this.getBanner();
  },
};
</script>

<style lang="scss" scoped>
.banner {
  height: 570px;
  width: 100%;

  box-sizing: border-box;
  //相当于 align-items justify-items 的缩写
  place-items: center;

  display: grid;
  grid-template-areas: "hero";

  > * {
    box-sizing: border-box;
    grid-area: hero;
  }

  > img {
    object-fit: cover;
    height: 100%;
    width: 100%;
    z-index: -1;
    overflow: hidden;
  }

  .hero__content {
    text-align: left;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    width: 1280px;
    //max-width: 902px;
    align-items: flex-start;

    h1 {
      color: var(---333, #333);
 
      font-size: 40px;
      font-style: normal;
      font-weight: 500;
      line-height: 52px; /* 130% */
    }

    p {
      overflow: hidden;
      color: #666;
      text-overflow: ellipsis;
      white-space: wrap;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 28px; /* 175% */
    }
  }

  .sublist-b {
    transform: translate(0, 50%);

    &:empty {
      display: none;
    }
  }

  .boxs {
    position: relative;
    .sublist-img {
      &:empty {
        display: none;
      }

      transform: translate(0, 70%);
      display: grid;
      grid-gap: 8px;
      //grid-gap: 2px;
      grid-template-columns: 830px 442px;
      grid-template-rows: 168px 168px;
      grid-template-areas:
        " content  header"
        " content sidebar";
      color: #444;

      .sidebar {
        grid-area: sidebar;
        border: 2px solid #fff;
        background: url(<path-to-image>) lightgray 50% / cover no-repeat;
        box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
      }

      .content {
        grid-area: content;
        background: url(<path-to-image>) lightgray 0px -4.357px / 100% 127.357% no-repeat;
      }

      .header {
        grid-area: header;
        border: 2px solid #fff;
        background: url(<path-to-image>) lightgray 50% / cover no-repeat;
        box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
      }

      .box {
        color: #fff;
        //padding: 20px;
        display: grid;
        grid-template-areas: "hero";
        border: 2px solid #fff;
        background: url(<path-to-image>) lightgray 50% / cover no-repeat;
        box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);

        > * {
          box-sizing: border-box;
          grid-area: hero;
        }

        img {
          object-fit: cover;
          height: 100%;
          width: 100%;
          //z-index: -1;
          overflow: hidden;
        }

        h3 {
          color: #fff;
          // CSS 属性会覆盖grid或 flex 布局里的 align-items 值。在grid中，t aligns the item inside the [grid area](https://developer.mozilla.org/en-US/docs/Glossary/Grid_Areas). In Flexbox, it aligns the item on the [cross axis](https://developer.mozilla.org/en-US/docs/Glossary/Cross_Axis).齐。
          align-self: end;
          font-size: 16px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
          padding: 10px 24px;
          background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000 100%);
          margin-bottom: 0;
        }
      }

      .header {
        background-color: #999;
      }

      //.overlay {
      //  background-color: red;
      //  z-index: 10;
      //  grid-column: content-start / content-end;
      //  grid-row: header-start / content-end;
      //}
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BannerImg.vue